export interface RegistryItem {
  readonly id: string;
  readonly requiredPermissions: readonly string[];
}

export class Registry<TItem extends RegistryItem> {
  private readonly items = new Map<string, TItem>();

  register(item: TItem): void {
    if (this.items.has(item.id)) {
      throw new Error(`Registry item already exists: ${item.id}`);
    }
    this.items.set(item.id, item);
  }

  registerMany(items: readonly TItem[]): void {
    items.forEach((item) => this.register(item));
  }

  get(id: string): TItem | undefined {
    return this.items.get(id);
  }

  list(): readonly TItem[] {
    return [...this.items.values()];
  }

  listVisible(permissions: ReadonlySet<string>): readonly TItem[] {
    return this.list().filter((item) =>
      item.requiredPermissions.every((permission) => permissions.has(permission)),
    );
  }
}
